export default defineNuxtPlugin(async (nuxtApp) => {
  initAppleInit();
  initFacebookInit();
});
